var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThresholdAboveObj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 196,
    viewBox: "0 0 282 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247 98H35V161H247V98Z",
    fill: "#F8003B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M247 35H35V98H247V35Z",
    fill: "#12BB6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 133L70.687 125.097L93.2324 75.9839L110.926 114.371L149.453 63L177.992 114.371L200.537 120.581L224.51 114.371H235",
    stroke: "#F8003B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98.5H247",
    stroke: "#F8003B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 131.5C74.366 131.5 77.5 128.366 77.5 124.5C77.5 120.634 74.366 117.5 70.5 117.5C66.634 117.5 63.5 120.634 63.5 124.5C63.5 128.366 66.634 131.5 70.5 131.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 121.5C115.366 121.5 118.5 118.366 118.5 114.5C118.5 110.634 115.366 107.5 111.5 107.5C107.634 107.5 104.5 110.634 104.5 114.5C104.5 118.366 107.634 121.5 111.5 121.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178 120.5C181.59 120.5 184.5 117.59 184.5 114C184.5 110.41 181.59 107.5 178 107.5C174.41 107.5 171.5 110.41 171.5 114C171.5 117.59 174.41 120.5 178 120.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201 127.5C204.59 127.5 207.5 124.59 207.5 121C207.5 117.41 204.59 114.5 201 114.5C197.41 114.5 194.5 117.41 194.5 121C194.5 124.59 197.41 127.5 201 127.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224 120.5C227.59 120.5 230.5 117.59 230.5 114C230.5 110.41 227.59 107.5 224 107.5C220.41 107.5 217.5 110.41 217.5 114C217.5 117.59 220.41 120.5 224 120.5Z",
    fill: "#F8003B",
    stroke: "white",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35V161H247",
    stroke: "#CDCDD6",
    strokeWidth: 2.72632,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 61,
    width: 193,
    height: 75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 133L70.687 125.097L93.2324 75.9839L110.926 114.371L149.453 63L177.992 114.371L200.537 120.581L224.51 114.371H235",
    stroke: "#F8003B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183 46H58V98H183V46Z",
    fill: "#12BB6A"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 82.5C97.366 82.5 100.5 79.366 100.5 75.5C100.5 71.634 97.366 68.5 93.5 68.5C89.634 68.5 86.5 71.634 86.5 75.5C86.5 79.366 89.634 82.5 93.5 82.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149 69.5C152.59 69.5 155.5 66.5899 155.5 63C155.5 59.4101 152.59 56.5 149 56.5C145.41 56.5 142.5 59.4101 142.5 63C142.5 66.5899 145.41 69.5 149 69.5Z",
    fill: "#12BB6A",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThresholdAboveObj);
export default __webpack_public_path__ + "static/media/threshold_above_obj.9c03ca0247e51bb1b66b952a43c7f440.svg";
export { ForwardRef as ReactComponent };